import inject from './inject';
import load from './load';

export default { load, inject };



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/